import styles from './ActivityLogTable.module.scss';
import { Table } from 'components/UI/V3/Table/Table';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { TableBody } from 'components/UI/V3/Table/Body/TableBody';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';

interface ActivityLog {
    task: string;
    date: string;
    time: string;
    staff: string;
}

const MOCK_ACTIVITY_LOGS: ActivityLog[] = [
    {
        task: 'A new booking was created for Zahida Contreras by Ruth Rojas',
        date: 'Monday, October 21, 2024',
        time: '4:19 PM',
        staff: 'John Doe'
    },
    {
        task: 'Alejandro Kullmer was assigned to the appointment',
        date: 'Monday, October 21, 2024',
        time: '4:19 PM',
        staff: 'John Doe'
    },
    {
        task: 'A new booking was created for Zahida Contreras by Ruth Rojas',
        date: 'Monday, October 21, 2024',
        time: '4:19 PM',
        staff: 'John Doe'
    },
    {
        task: 'Ruth Rojas was assigned to the appointment',
        date: 'Monday, October 21, 2024',
        time: '4:19 PM',
        staff: 'John Doe'
    }
];

export default function ActivityLogTable() {
    return (
        <Table fullHeight>
            <TableHeader>
                <TableHeaderCell>Task</TableHeaderCell>
                <TableHeaderCell>Date</TableHeaderCell>
                <TableHeaderCell>Time</TableHeaderCell>
                <TableHeaderCell>Staff</TableHeaderCell>
            </TableHeader>

            <TableBody>
                {MOCK_ACTIVITY_LOGS.map((log, idx) => (
                    <TableRow key={idx}>
                        <TableCell>{log.task}</TableCell>
                        <TableCell>{log.date}</TableCell>
                        <TableCell>{log.time}</TableCell>
                        <TableCell>{log.staff}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}
